function componentWillUnmount () {
  window.onbeforeunload = null
}

export default componentWillUnmount
